export enum eLanguage {
  EN = 'en',
  ES = 'es',
  PT = 'pt',
}
